import { useEmbedConfig } from 'features/EmbedConfig';
import deriveCanonicalBase from 'utils/seo/deriveCanonicalBase';

/**
 * The page every listing canonical is built on: the current page, or in browser mode the router's base
 * path. See {@link deriveCanonicalBase}.
 */
const useCanonicalBase = (): string => {
  const { basePath, routerType } = useEmbedConfig();
  return deriveCanonicalBase(document.location, { basePath, routerType });
};

export default useCanonicalBase;
